export var addProtocolIfMissing = function (url) {
    if (!/^(?:f|ht)tps?:\/\//.test(url)) {
        url = 'http://' + url;
    }
    return url;
};
//# sourceMappingURL=index.js.map